import { LinkifyIt } from "linkify-it";

const linkify = new LinkifyIt({ fuzzyLink: true });
const linkifyUrlOnly = new LinkifyIt({ fuzzyLink: true, fuzzyEmail: false });

/**
 * Returns true when the entire input is a URL.
 * Used on the landing page to decide whether to route to /fetching (URL fetch) or /review (text claim).
 */
export function isUrl(text: string): boolean {
  const trimmed = text.trim();
  const matches = linkifyUrlOnly.match(trimmed);
  if (!matches || matches.length !== 1) return false;
  const m = matches[0];
  return m.raw === trimmed && m.schema !== "mailto:";
}

/**
 * Returns true when text contains at least one link or email address.
 * Used to validate user-authored prose (bio, credentials, insight body).
 */
export function containsLinks(text: string): boolean {
  return linkify.match(text) !== null;
}
